import { useEffect, useState } from "react";
import { Card, Button, Container, Row, Col, Table } from "react-bootstrap";
import useLocalStorageState from "use-local-storage-state";
import { GetRequest } from   "../../Utils/hooks/ApiHandler" ;
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye, faGem, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "sonner";
import TooltipLable from "../../Utils/TooltipLable";
import { BsArrowLeft } from "react-icons/bs";

const SubscriptionDetails = () => {
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer");

  const customer_id = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;

  const headers = {
    Authentication: rf,
    Authorization: token,
  };

  const fetchSubscription = async () => {
    setLoading(true);
    try {
      const res = await GetRequest(
        `plan/fetchCustomerSubscription/${customer_id}`,
        { headers },
        { customer, setCustomer, rf, navigate }
      );
      console.log("API RESPONSE :", res);

      if (res?.status === "success") {
        setSubscriptionData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customer_id) {
      fetchSubscription();
    }
  }, [customer_id]);

  const customerSubscriptionId = subscriptionData?.[0]?.subscription_id;
  const activePlan = subscriptionData?.find(
    item => item.customer_plan_status === "Active"
  );
  const currentPlan = activePlan || subscriptionData?.[0];

  const cancelSubscription = async () => {
    try {
      setLoading(true)
      const res = await GetRequest(
        `plan/cancelSubscription/${customerSubscriptionId}`,
        { headers },
        { customer, setCustomer, rf, navigate }
      );
      toast.success(res.message);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  const getRemainingDays = (endDate) => {
    if (!endDate) return 0;

    const today = new Date();
    const end = new Date(endDate);

    const diffTime = end.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 0 ? diffDays : 0;
  }

  const remainingDays = getRemainingDays(subscriptionData[0]?.end_date);


  const subscriptionTableData = [...(subscriptionData || [])].sort((a,b)=>{
    if(a.customer_plan_status === "Active") return -1;
    if(b.customer_plan_status === "Active") return 1;
    return 0;
  })

  return <>
    <div style={{ minHeight: "100vh", padding: "20px 0", marginBottom: "10px" }}>
      <Container fluid>
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h5>Manage Subscriptions</h5>
            <Button className="btn btn-default-outline" onClick={() => navigate(-1)}>
              <BsArrowLeft className="me-1" /> Back
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "400px" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <Row className="align-items-stretch">
              {/* USER CURRENT PLAN */}
              <Col md={4}>
                <Card
                  style={{
                    border: "1px solid #3b82f6",
                    borderRadius: "8px",
                    height:"136.84px"
                  }}
                >
                  <Card.Body className="p-3">
                    {/* Top row: Plan + Price */}
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="d-flex gap-2 mb-3">
                          <div className=" d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: "#d4dcdd", height: "35px", width: "35px", borderRadius: "5px" }}>
                            <FontAwesomeIcon icon={faGem} style={{ color: "#3687e3" }} />
                          </div>
                          <div className="flex-column">
                            <h5
                              className="fw-bold mb-0"
                              style={{ fontSize: "16px" }}
                            >
                              {currentPlan?.plan_name}
                            </h5>
                            <p
                              className="text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {remainingDays} days remaining
                            </p>
                          </div>
                        </div>

                      </div>

                      {/* Price */}
                      <div>
                        <div className="fw-bold text-primary">
                          ₹{Number(currentPlan?.amount / 100).toLocaleString()}
                          <span className="text-muted small" style={{ fontSize: "12px" }}> /month</span>
                        </div>
                        <div className="text-end mt-0">
                          <span
                            className="px-2 py-1 rounded-pill"
                            style={{
                              fontSize: "10px",
                              color:
                                currentPlan?.customer_plan_status === "Active"
                                  ? "#16a34a"
                                  : currentPlan?.customer_plan_status === "Delete"
                                    ? "#dc2626"
                                    : "#f59e0b",
                              backgroundColor:
                                currentPlan?.customer_plan_status === "Active"
                                  ? "#dcfce7"
                                  : currentPlan?.customer_plan_status === "Delete"
                                    ? "#fee2e2"
                                    : "#fef3c7",
                            }}
                          >
                            {currentPlan?.customer_plan_status}
                          </span>
                        </div>

                      </div>
                    </div>

                    {/* Button */}
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={cancelSubscription}
                      >
                        Cancel Subscription
                      </Button>

                      <span style={{ color: "#0d6efd" }}
                        onClick={() =>
                          navigate("/paymentDetails", {
                            state: {
                              customer_subscription_id: currentPlan?.customer_subscription_id,
                            }
                          })
                        }>

                        <TooltipLable
                          text={<small style={{ fontSize: "12px" }}>Upcoming Payments</small>}
                          tooltip="View payment history"
                          placement="right"
                          style={{ color: "#7a3a5e" }}
                        />
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

                <Col md={8}>
                  <div
                    className="alert alert-warning mb-5 mb-0 d-flex align-items-center"
                    style={{ backgroundColor: "#fff3cd", border: "1px solid #dfa907",  height:"136.84px" }}
                  >

                    <div className="d-flex align-items-start gap-3">
                      {/* Icon */}
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                      >
                        <i className="bi bi-info-circle"
                        style={{fontSize: "25px"}}></i>
                      </div>

                      {/* Text */}
                      <div>
                        <p className="mb-0 fw-500" style={{ color: "#856404", fontSize:"14px" }}>
                          If enabled, this option will automatically renew your subscription
                          when the current plan expires. 
                        </p>
                        <p className="mb-0 fw-500" style={{ color: "#856404" }}>
                          However, please note that this may
                          prevent you from switching to a different plan before the renewal.
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>

            </Row>


            

            {/* Payment Methods Section */}
            

            <Row className="mb-3">
              <Col md={12}>
                <h6 className="fw-500 mb-3">Billing History</h6>

                <Table responsive className="align-middle" style={{
                  backgroundColor: "#fff",
                  border: "1px solid #d3d3d3",
                  borderRadius: "7px",
                  boxShadow: "0 0 17px #f3f3f3"
                }}>
                  <thead className="fw-500 text-center text-black">
                    <tr>
                      <th>Date</th>
                      <th>Details</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {subscriptionTableData.map((item, index) => (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td>{item.start_date}</td>
                        <td>{item.plan_name}</td>
                        <td className="fw-semibold">{item.amount
                          ? `₹${Number(item.amount / 100).toLocaleString()}`
                          : "-"}</td>
                        <td>
                          <span
                            className="px-2 py-1 rounded-pill"
                            style={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color:
                                item.customer_plan_status === "Active"
                                  ? "#16a34a"
                                  : item.customer_plan_status === "Delete"
                                    ? "#dc2626"
                                    : "#f59e0b",
                              backgroundColor:
                                item.customer_plan_status === "Active"
                                  ? "#dcfce7"
                                  : item.customer_plan_status === "Delete"
                                    ? "#fee2e2"
                                    : "#fef3c7",
                            }}
                          >
                            {item.customer_plan_status}
                          </span>
                        </td>

                        <td className="text-center">
                          <FontAwesomeIcon icon={faDownload} className="me-3 cursor-pointer" style={{ cursor: "pointer" }} />
                          <FontAwesomeIcon icon={faEye} className="me-3 cursor-pointer" style={{ cursor: "pointer" }} />
                          <FontAwesomeIcon icon={faTrash} className="me-3 cursor-pointer" style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </>

        )}
      </Container>
    </div>

  </>

};

export default SubscriptionDetails;